import { render, staticRenderFns } from "./RingStatistics.vue?vue&type=template&id=13a18b7e&scoped=true&"
import script from "./RingStatistics.vue?vue&type=script&lang=js&"
export * from "./RingStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RingStatistics.vue?vue&type=style&index=0&id=13a18b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a18b7e",
  null
  
)

export default component.exports